
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"currentColor","d":"M12.003 4.448A7.554 7.554 0 005.07 9H7l-2.5 3L2 9h1.992a8.552 8.552 0 110 6H5.07a7.554 7.554 0 0014.485-3 7.552 7.552 0 00-7.552-7.552zM12 7.885a.5.5 0 00-1 0v4.962l.324.121 4 1.5a.5.5 0 10.352-.936L12 12.153V7.885z"}})])
          )
        }
      }
    